import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Chip from "@mui/material/Chip";


import Button from '@mui/material/Button';

import { updateDefs } from "../Services";
import { validator } from "../../../Js/Validator";
import { Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { userLogs } from "../../../Js/Common";

const CreateEditEnumeration = (props) => {
    // Hooks
    const navigate = useNavigate();

    // State
    const [errorEnumMessage, setErrorEnumMessage] = useState(null);
    const [errorDescMessage, setErrorDescMessage] = useState(null);
    const [errorMemberMessage, setErrorMemberMessage] = useState(null);

    const [enumName, setEnumName] = useState(null);
    const [enumDescription, setEnumDescription] = useState(null);
    const [newMember, setNewMember] = useState('');
    const [multipleMember, setMultipleMember] = useState([]);
    const [mode, setMode] = useState(props.mode);

    // Redux state
    const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

    // React logic hooks
    useEffect(() => {
        if (mode == "edit") {
            setEnumName(props.currentKeyData.name);
            setEnumDescription(props.currentKeyData.description);
            setMultipleMember(props.currentKeyData.data);
        }
    }, [mode]);

    // Update defs for new and edit enumeration
    const handleSubmit = async () => {
        enumNameValidate();
        enumDescriptionValidate();
        if (multipleMember.length == 0) {
            setErrorMemberMessage('Minimum one member required');
            return;
        }

        if (!errorEnumMessage && !errorDescMessage && !errorMemberMessage && multipleMember.length > 0) {
            if (props.enumData) {
                let enumObjData = props.enumData;
                let res1 = {};
                let outcome = {};
                if (mode == 'create') {
                    let dataObj = {
                        id: Math.random().toString(36).substr(7),
                        name: enumName.trim(),
                        type: 'Custom',
                        description: enumDescription.trim(),
                        data: multipleMember
                    };
                    enumObjData.created_by = userInfo.uid;
                    enumObjData.keydata.push(dataObj);

                    // logs value
                    res1.oldValue = "";
                    res1.newValue = dataObj;

                    outcome.action = "add";
                    outcome.value = res1;

                } else if (mode == 'edit') {
                    let newData = enumObjData.keydata;
                    let currentKeyData = props.currentKeyData;
                    let pos = newData.findIndex(obj => obj.id == currentKeyData.id);
                    let updateDataObj = {
                        id: currentKeyData.id,
                        type: currentKeyData.type,
                        name: enumName.trim(),
                        description: enumDescription.trim(),
                        data: multipleMember
                    };
                    enumObjData.keydata[pos] = updateDataObj;

                    // logs value
                    res1.oldValue = "";
                    res1.newValue = updateDataObj;

                    outcome.action = "edit";
                    outcome.value = res1;
                }
                await updateDefs(enumObjData, enumObjData.uid, enumObjData.site_uuid);

                // insert log for enumeration
                let logResponse = await userLogs({
                    actor: userInfo.uid,
                    verb: "enum",
                    target: enumObjData.uid,
                    outcome: outcome,
                    site_uuid: userInfo.site_uuid,
                });

                resetState();
                props.isEnumeration(true, null, null);
            }
        }
    }

    // Add Member into chip component
    const handleMembers = () => {
        let newData = [...multipleMember];
        let index = newData.indexOf(newMember.trim());
        if (index === -1) {
            setMultipleMember([...multipleMember, newMember.trim()]);
            setNewMember('');
            setErrorMemberMessage(null);
            return
        } else {
            setErrorMemberMessage('Duplicate member not allowed');
            return;
        }
    }

    // Remove member one by one
    const removeChip = (index) => {
        let newData = [...multipleMember];
        newData.splice(index, 1);
        setMultipleMember(newData);
    }

    // Validate name on blur
    const enumNameValidate = () => {
        let validate = validator({ required: true, value: enumName });
        if (!validate["validate"]) {
            setErrorEnumMessage(validate["message"]);
        } else {
            setErrorEnumMessage(null);
        }
    }

    // Validate description on blur
    const enumDescriptionValidate = () => {
        let validate = validator({ required: true, value: enumDescription });
        if (!validate["validate"]) {
            setErrorDescMessage(validate["message"]);
        } else {
            setErrorDescMessage(null);
        }
    };

    const resetState = () => {
        setEnumName('');
        setEnumDescription('');
        setNewMember('');
        setMultipleMember([]);

        setErrorEnumMessage(null);
        setErrorDescMessage(null);
        setErrorMemberMessage(null);
    };

    return (
        <Grid container spacing={1} justifyContent="center" marginTop={3}>
            <Grid item xs={9} sm={9} md={9}>
                <Grid container>
                    <Grid item xs={12}>
                        <Box sx={{ textAlign: 'right' }}>
                            <Button sx={{ backgroundColor: '#3eda00ff', textTransform: 'inherit', borderRadius: 10, fontWeight: '500', color: '#FFFFFF', '&:hover': { backgroundColor: '#3eda00ff', color: '#FFFFFF' }, '@media (min-width: 1636px)': { fontSize: '1.4rem', px: 2 } }} onClick={() => { handleSubmit() }}>
                                Save
                            </Button>
                            <Button sx={{ backgroundColor: '#F5F5F5', textTransform: 'inherit', borderRadius: 10, fontWeight: '500', mx: 1, '&:hover': { backgroundColor: '#3eda00ff', color: '#FFFFFF' }, '@media (min-width: 1636px)': { fontSize: '1.4rem', mx: 1, px: 2 } }} onClick={() => { props.isEnumeration(true, null, null); }}>
                                Cancel
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
                <Typography sx={{ mt: 2, color: '#5f5600ff', fontWeight: '600', fontSize: '0.9rem', textAlign: 'left', pl: 2, '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>Category</Typography>
                <TextField
                    placeholder="Category (e.g. Name of Planets)"
                    variant="standard"
                    fullWidth
                    value={enumName}
                    onBlur={() => enumNameValidate()}
                    onInput={(event) => { setEnumName(event.target.value); }}
                    sx={{ mt: 1, borderRadius: 10 }}
                    InputProps={{ inputProps: 
                        { sx: { 
                            padding: 1, 
                            borderRadius: 20,
                            borderRadius: 40,
                            backgroundColor: '#F5F5F5'
                            , '@media (min-width: 1636px)': { fontSize: '1.4rem' }, 
                        }
                    },
                        disableUnderline: true,
                    }}

                />
                {errorEnumMessage &&
                    <Typography sx={{ color: 'primary.error', fontWeight: '400', fontSize: '0.9rem', textAlign: 'left', pl: 2, '@media (min-width: 1636px)': { fontSize: '1.1rem' } }}>{errorEnumMessage}</Typography>
                }
                <Typography sx={{ mt: 4, color: '#5f5600ff', fontWeight: '600', fontSize: '0.9rem', textAlign: 'left', pl: 2, '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>Description</Typography>
                <TextField
                    placeholder="Sub-category (e.g. Mercury, Venus, Earth, Mars)"
                    variant="standard"
                    fullWidth
                    value={enumDescription}
                    onBlur={() => enumDescriptionValidate()}
                    onInput={(event) => { setEnumDescription(event.target.value) }}
                    sx={{ mt: 1 }}
                    InputProps={{ inputProps: 
                        { sx: { 
                            padding: 1, 
                            borderRadius: 20,
                            borderRadius: 40,
                            backgroundColor: '#F5F5F5'
                            , '@media (min-width: 1636px)': { fontSize: '1.4rem' }, 
                        }
                    },
                        disableUnderline: true, }}
                />
                {errorDescMessage &&
                    <Typography sx={{ color: 'primary.error', fontWeight: '400', fontSize: '0.9rem', textAlign: 'left', pl: 2 ,'@media (min-width: 1636px)': { fontSize: '1.1rem' } }}>{errorDescMessage}</Typography>
                }
                <Typography sx={{ mt: 4, color: '#5f5600ff', fontWeight: '600', fontSize: '0.9rem', textAlign: 'left', pl: 2, '@media (min-width: 1636px)': { fontSize: '1.4rem' } }}>New Member</Typography>
                <TextField
                    placeholder="Add Member"
                    variant="standard"
                    fullWidth
                    value={newMember}
                    onInput={(event) => { setNewMember(event.target.value) }}
                    onKeyDown={(event) => { if (event.keyCode === 13) { handleMembers() } }}
                    sx={{ mt: 1 }}
                    InputProps={{ inputProps: 
                        { sx: { 
                            padding: 1, 
                            borderRadius: 20,
                            borderRadius: 40,
                            backgroundColor: '#F5F5F5'
                            , '@media (min-width: 1636px)': { fontSize: '1.4rem' }, 
                        }
                    },
                     disableUnderline: true, }}
                />
                {errorMemberMessage &&
                    <Typography sx={{ color: 'primary.error', fontWeight: '400', fontSize: '0.9rem', textAlign: 'left', pl: 2,'@media (min-width: 1636px)': { fontSize: '1.1rem' } }}>{errorMemberMessage}</Typography>
                }

                <Box sx={{ textAlign: 'left' }}>
                    {
                        multipleMember.map((item, index) => {
                            return (
                                <Chip sx={{ mx: 1, mt: 1, fontSize: '0.8rem', backgroundColor: '#F5F5F5', color: '#3eda00ff', fontWeight: '500' ,borderRadius: 50,'@media (min-width: 1636px)': { fontSize: '1.4rem',p:1, py:3 } }} label={item} onDelete={() => { removeChip(index) }}
                                    deleteIcon={<CloseIcon/>}
                                    size="small" />
                            )
                        })
                    }
                </Box>
            </Grid>
        </Grid>
    )
}

export default CreateEditEnumeration;